import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  SxProps,
  IconButton,
} from "@mui/material";
import React from "react";

interface LegalDialogProps {
  open: boolean;
  onClose?: () => void;
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  disableClose?: boolean;
  paperSx?: SxProps;
  contentSx?: SxProps;
  showTopDivider?: boolean;
  showBottomDivider?: boolean;
  showClose?: boolean;
}

const LegalDialog: React.FC<LegalDialogProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  disableClose = false,
  paperSx,
  contentSx,
  showTopDivider = true,
  showBottomDivider = true,
  showClose = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={disableClose ? undefined : onClose}
      fullWidth
      maxWidth={maxWidth}
      aria-labelledby="legal-dialog-title"
      slotProps={{
        paper: { sx: { borderRadius: 1.5, boxShadow: 20, ...paperSx } },
      }}
    >
      <DialogTitle
        id="legal-dialog-title"
        className="pb-2"
        sx={{ position: "relative" }}
      >
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        {showClose && onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {showTopDivider && <Divider />}
      <DialogContent
        className="pt-5"
        sx={{ "& .MuiTypography-root": { color: "#000" }, ...contentSx }}
      >
        {children}
      </DialogContent>
      {showBottomDivider && <Divider />}
      {actions && (
        <DialogActions
          className="p-4 gap-3"
          sx={{ justifyContent: "center", pt: 3, width: "100%" }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default LegalDialog;
